<template>
  <div id="footer_content" class="footer_content">
    <nav class="fc_news"><a href=""><img src="../assets/banner/1baoshang.jpg" alt=""></a><a href=""><img src="../assets/banner/1huada.jpg" alt=""></a><a href=""><img src="../assets/banner/1baoshang.jpg" alt=""></a></nav>
    <ul class="list_container">
      <li><a href="/xy_web/" class="logo"><img src="../assets/logo_black.png" alt="" /></a></li>
      <li>
        <ul class="fb">
          <li><span class="fp_bl">freshcoo@126.com</span></li>
          <li><span class="fp_bl">729147024@qq.com</span></li>
        </ul>
      </li>
      <li>
        <p><span class="fp_bl fp_title">Shenzhen</span></p>
        <p>
          <span>深圳市福田保税区广兰道6号深装总大厦A座650</span>
          <span>616 Block A, SDCIC mansion, 6, Guanglan Road, Bonded area, Futian, Shenzhen</span></p>
      </li>
      <li>
        <p><span class="fp_bl fp_title">Beijing</span></p>
        <p>
          <span>北京市东城区东四十条94号亮点设计中心B座一层112-113</span>
          <span>112-113, 1st floor, Block B, 94, Dongsishi, Dongcheng District, Beijing</span></p>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "FooterTwo"
  }
</script>

<style type="text/less" lang="less">
  .footer_content {
    .fc_news {
      a {
        width: 50%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterTwo.vue